import React, { useState } from 'react'
import { Tabs } from 'components/Tabs'
import { Preview, Section, Col } from 'component-catalog/previews/PreviewKit'

const basicTabs = [
  { key: 'overview', title: 'Overview' },
  { key: 'details', title: 'Details' },
  { key: 'activity', title: 'Activity' },
]

const tabsWithBadges = [
  { key: 'inbox', title: 'Inbox', badge: 12 },
  { key: 'sent', title: 'Sent', badge: 3 },
  { key: 'drafts', title: 'Drafts', badge: 0 },
  { key: 'archived', title: 'Archived' },
]

const manyTabs = [
  { key: 'a', title: 'Contacts' },
  { key: 'b', title: 'Companies' },
  { key: 'c', title: 'Deals' },
  { key: 'd', title: 'Emails', badge: 5 },
  { key: 'e', title: 'Tasks', badge: 2 },
  { key: 'f', title: 'Files' },
]

function TabContent({ active }: { active: string }) {
  return (
    <div className="mt-3 px-3 py-2 text-sm text-fg-secondary border border-line rounded bg-surface-alt">
      Active: <strong className="text-fg">{active}</strong>
    </div>
  )
}

export function TabsMock(): React.ReactElement {
  const [basic, setBasic] = useState('overview')
  const [badged, setBadged] = useState('inbox')
  const [many, setMany] = useState('a')

  return (
    <Preview>
      <Section label="Basic — no badges">
        <Col>
          <Tabs
            tabs={basicTabs}
            selectedTab={basic}
            setSelectedTab={setBasic}
          />
          <TabContent active={basic} />
        </Col>
      </Section>

      <Section label="With numeric badges — badge=0 renders but looks empty">
        <Col>
          <Tabs
            tabs={tabsWithBadges}
            selectedTab={badged}
            setSelectedTab={setBadged}
          />
          <TabContent active={badged} />
        </Col>
      </Section>

      <Section label="Many tabs — equal-flex layout">
        <Col>
          <Tabs tabs={manyTabs} selectedTab={many} setSelectedTab={setMany} />
          <TabContent active={many} />
        </Col>
      </Section>
    </Preview>
  )
}
